import { observer } from 'mobx-react-lite';
import { ConfirmPopup } from '../../../../components/common-components/pop-up/Popup';
import { useStore } from '../../../../hooks/useStore';
import { formatDecimalAmount } from '../../../../utils/numberUtils';
import styles from './DeleteExpenseDialog.module.css';

const formatDate = (value?: string | Date) => {
  if (!value) {
    return '—';
  }

  return new Date(value).toLocaleDateString('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

const DeleteExpenseDialog = () => {
  const { popupStore, expenseStore } = useStore();
  const expense = expenseStore.expenseToDelete;

  const handleClose = () => {
    popupStore.setIsDeleteExpenseConfirmationOpen(false);
    expenseStore.setExpenseToDelete(null);
  };

  const handleConfirm = async () => {
    if (!expense?.id) {
      return;
    }

    await expenseStore.deleteExpense(expense.id);
    handleClose();
  };

  const message = expense ? (
    <div className={styles.content}>
      <p className={styles.message}>Aşağıdaki harcama kaydını silmek istediğinizden emin misiniz?</p>
      <ul className={styles.detailList}>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Kullanıcı</span>
          <span className={styles.detailValue}>{expense.userName || '—'}</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Miktar</span>
          <span className={styles.detailValue}>{formatDecimalAmount(expense.amount)} ₺</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Harcama Tarihi</span>
          <span className={styles.detailValue}>{formatDate(expense.expenseDate)}</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Açıklama</span>
          <span className={styles.detailValue}>{expense.description || '—'}</span>
        </li>
      </ul>
      <p className={styles.warning}>Bu işlem geri alınamaz.</p>
    </div>
  ) : (
    'Bu harcama kaydını silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.'
  );

  const result = (
    <ConfirmPopup
      isOpen={popupStore.isDeleteExpenseConfirmationOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      intent="delete"
      title="Harcama Kaydı Silme Onayı"
      description="Silme işlemi kalıcıdır"
      message={message}
      closeOnConfirm={false}
    />
  );

  return result;
};

export default observer(DeleteExpenseDialog);
